export default "__VITE_ASSET__CSVeLy$W__"